export default "__VITE_ASSET__Duf5tl14__"